/* Sully & Co. homepage helpers. Loaded on the homepage only. */
(function () {
  var PHONE = window.matchMedia('(max-width: 749px)');
  var CHEVRON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  function tabs() {
    return document.querySelectorAll('.index-tab-collections .tab-content, [id*="TabCollections"] .tab-content');
  }

  // On phones the featured tile becomes a banner above the products. The grid is a
  // slider, so the tile is lifted out of it rather than asked to span its columns.
  function placeBanner(tab) {
    var lifted = tab.querySelector('.sully-banner');
    var grid = tab.querySelector('.grid');
    if (PHONE.matches) {
      if (lifted || !grid) return;
      var tile = grid.querySelector(':scope > .grid-item.product-item--featured');
      if (!tile) return;
      var banner = document.createElement('div');
      banner.className = 'sully-banner';
      banner.appendChild(tile);
      var outer = tab.querySelector('.grid-outer') || grid;
      outer.parentNode.insertBefore(banner, outer);
      tab.classList.add('sully-tab--lifted');
    } else if (lifted) {
      var back = lifted.firstElementChild;
      if (back && grid) grid.insertBefore(back, grid.firstChild);
      lifted.remove();
      tab.classList.remove('sully-tab--lifted');
    }
  }

  // Four polos per tab, with the rest a tap away.
  function addShowMore(tab) {
    var container = tab.querySelector('.grid-container') || tab;
    if (container.querySelector('.sully-more')) return;
    var products = tab.querySelectorAll('.grid > .grid-item.product-item:not(.product-item--featured)');
    if (products.length <= 4) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sully-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>Show all ' + products.length + '</span>' + CHEVRON;
    btn.addEventListener('click', function () {
      var open = tab.classList.toggle('sully-tab--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('span').textContent = open ? 'Show less' : 'Show all ' + products.length;
      if (!open) container.scrollIntoView({ block: 'nearest' });
    });
    container.appendChild(btn);
  }

  // Hero heading: each sentence on its own line, so "Comfort comes first." never
  // breaks. The words are untouched; only line breaks are added.
  function splitHeroTitle() {
    var title = document.querySelector('[id$="__section_video_QX4qtG"] .hero__title');
    if (!title || title.querySelector('.sully-hero-line')) return;
    var text = title.textContent.replace(/\s+/g, ' ').trim();
    var match = text.match(/^(.+?[.!?])\s+(.+)$/);
    if (!match) return;
    var lead = document.createElement('span');
    lead.className = 'sully-hero-line sully-hero-line--lead';
    lead.textContent = match[1];
    var rest = document.createElement('span');
    rest.className = 'sully-hero-line';
    rest.textContent = match[2];
    title.textContent = '';
    title.appendChild(lead);
    title.appendChild(document.createTextNode(' '));
    title.appendChild(rest);
  }

  // Trust line on phones: the columns stay left-aligned to each other, but the block as a
  // whole is shifted so its visible edges (first icon to longest label) sit centered.
  function centerTrustRow() {
    var grid = document.querySelector('[id$="__section_text_row_dRNmFz"] .grid');
    if (!grid) return;
    grid.style.transform = '';
    if (!PHONE.matches) return;
    var box = grid.getBoundingClientRect();
    var left = Infinity;
    var right = -Infinity;
    function take(rect) {
      if (!rect.width) return;
      left = Math.min(left, rect.left);
      right = Math.max(right, rect.right);
    }
    grid.querySelectorAll('.icon__animated').forEach(function (icon) {
      take(icon.getBoundingClientRect());
    });
    grid.querySelectorAll('.column__heading').forEach(function (label) {
      var range = document.createRange();
      range.selectNodeContents(label);
      Array.prototype.forEach.call(range.getClientRects(), take);
    });
    if (!isFinite(left) || !isFinite(right)) return;
    var shift = Math.round((box.left + box.right) / 2 - (left + right) / 2);
    if (shift) grid.style.transform = 'translateX(' + shift + 'px)';
  }

  function init() {
    splitHeroTitle();
    centerTrustRow();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(centerTrustRow);
    window.addEventListener('load', centerTrustRow);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(centerTrustRow, 150);
    });
    tabs().forEach(function (tab) {
      placeBanner(tab);
      addShowMore(tab);
    });
  }

  function onBreakpoint() {
    tabs().forEach(placeBanner);
    centerTrustRow();
  }

  if (PHONE.addEventListener) {
    PHONE.addEventListener('change', onBreakpoint);
  } else if (PHONE.addListener) {
    PHONE.addListener(onBreakpoint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
